export default {
  email: [
    { required: true, message: 'Email is required.' },
    { type: 'email', message: 'Email is invalid' }
  ],
  first_name: [
    { required: true, message: 'First name is required.' },
    {
      pattern: /^[A-Za-z0-9\s\-.'']+$/,
      message: 'First name contains invalid characters.'
    },
    {
      pattern: /\S/,
      message: 'First name cannot be empty or contain only whitespace.'
    }
  ],
  last_name: [
    { required: true, message: 'Last name is required.' },
    {
      pattern: /^[A-Za-z0-9\s\-.'']+$/,
      message: 'Last name contains invalid characters.'
    },
    {
      pattern: /\S/,
      message: 'Last name cannot be empty or contain only whitespace.'
    }
  ],
  subject: [
    { required: true, message: 'Subject is required.' },
    {
      pattern: /^[A-Za-z\s]+$/,
      message: 'Subject must only contain letters and spaces.'
    },
    {
      pattern: /\S/,
      message: 'Subject cannot be empty or contain only whitespace.'
    }
  ],
  message: [
    { required: true, message: 'Message is required.' },
    {
      pattern: /^[A-Za-z0-9\s.!?,()\-’'\n]+$/,
      message: 'Message contains invalid characters.'
    },
    {
      pattern: /\S/,
      message: 'Message cannot be empty or contain only whitespace.'
    }
  ]
}
